/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Modal/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import FileUploaderDashboardModal from 'DesignSystem/FileUploaderDashboardModal/react'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Modal({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/Upload/Content/Modal",
  getKey
  
}) {
let onClose = fromHelpers.useOnClose({
  children,
  viewPath,
  getKey
  
})
  return (<React.Fragment
>
<FileUploaderDashboardModal
  viewPath={`${viewPath}/FileUploaderDashboardModal`}
 isOpen={true}
 onClose={onClose}
/>
<FileUploaderPluginS3
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 isLegacyBucket={true}
 excludeKeyFileExtension={true}
 prefix="patientdoc"
 getKey={getKey}
/>
{children}
</React.Fragment>)
}